export const BASE_ROUTE = 'ws1/account-settings-users-gateway';
export const ACCOUNT_MANAGE_PERMISSION = 'account.manage';
export const INVITE_LIMIT = 4;
export const ROLES_PERMISSIONS_ADVANCED_ENTITLEMENT = 'roles-and-permissions.advanced';
export const ACCOUNT_USERS_ENTITLEMENT = 'account-users';
export const USER_INVITATION_ROUTE = '/v1/invitation';
//# sourceMappingURL=consts.js.map